/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Tlm_2Inputs */

const en_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`qa_gate`)
};

const ar_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة الجودة`)
};

const bn_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QA গেট`)
};

const de_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QA-Gate`)
};

const es_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puerta de calidad`)
};

const fr_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porte de qualité`)
};

const pt_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porta de qualidade`)
};

const zh_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量门禁`)
};

const tr_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalite kapısı`)
};

const ru_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ворота качества`)
};

const pl_svc_retainer_tlm_2 = /** @type {(inputs: Svc_Retainer_Tlm_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bramka jakości`)
};

/**
* | output |
* | --- |
* | "qa_gate" |
*
* @param {Svc_Retainer_Tlm_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_tlm_2 = /** @type {((inputs?: Svc_Retainer_Tlm_2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Tlm_2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_tlm_2(inputs)
	if (locale === "bn") return bn_svc_retainer_tlm_2(inputs)
	if (locale === "de") return de_svc_retainer_tlm_2(inputs)
	if (locale === "es") return es_svc_retainer_tlm_2(inputs)
	if (locale === "fr") return fr_svc_retainer_tlm_2(inputs)
	if (locale === "pt") return pt_svc_retainer_tlm_2(inputs)
	if (locale === "zh") return zh_svc_retainer_tlm_2(inputs)
	if (locale === "tr") return tr_svc_retainer_tlm_2(inputs)
	if (locale === "ru") return ru_svc_retainer_tlm_2(inputs)
	if (locale === "pl") return pl_svc_retainer_tlm_2(inputs)
	return en_svc_retainer_tlm_2(inputs)
});